import { DataActionContainer, DataTableFilter, DataTableFilterButton, DataTableFilterContainer, DataTableFilterData, DataTableFilterDelete, FilterContainer } from "./Components";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faSearch, faRefresh } from '@fortawesome/free-solid-svg-icons';
import { useDataTable } from "../../hooks/useDataTable";
import { useState } from "react";
import { useModal } from "../../hooks/useModal";
import { useTranslation } from "react-i18next";
import { Button, Dropdown, Form, InputGroup } from "react-bootstrap";
import { DataTableDropdown } from "./DataTableDropdown";
import { DATA_TABLE_FILTER } from "./FilterPopup";
import { classNames } from "../../helper";
import { useParams } from "react-router-dom";
import moment from "jalali-moment";
export const TableFilters = ({col}) => {
    const {t} = useTranslation();
    const {uid} = useParams();
    const {
        findColumnByKey, 
        filterConfig, 
        openFilterPopup,
        appendFilter,
        clearFilter, 
        reloadData, 
        searchPlaceholder
    } = useDataTable();
    const [keyword, setKeyword] = useState(null);
    let filters = Object.keys(filterConfig);
    const onClickFilter = (e, column) => {
        openFilterPopup(column)
    }
    const onClickRemoveFilter = (e, column) => {
        clearFilter(column.key)
    }
    const onSearch = (e) => {
        if(keyword)
            appendFilter("keyword", keyword)
    }
    const onRefresh = (e) => {
        reloadData();
    }
    return (
        <DataTableFilterContainer>
            <InputGroup>
                <InputGroup.Text><FontAwesomeIcon icon={faSearch} /></InputGroup.Text>
                <Form.Control 
                    type="text" 
                    onChange={(e) => setKeyword(e.target.value)} 
                    name="keyword" 
                    onKeyDown={(e) => {
                        if(e.keyCode === 13){
                            onSearch(e);
                        }
                    }}
                    placeholder={searchPlaceholder??t("Search")+"..."}
                />
                <InputGroup.Text className={classNames(["btn-search", !keyword?"disabled":""])} onClick={onSearch}>{t("Search")}</InputGroup.Text>
                <InputGroup.Text className={classNames(["btn-refresh"])} onClick={onRefresh}><FontAwesomeIcon icon={faRefresh} /></InputGroup.Text>
            </InputGroup>
            <>
                {filters.map((key, index) => {
                    const column = findColumnByKey(key);
                    if(!column) return null;
                    let value = filterConfig[key];
                    if(column.filter === DATA_TABLE_FILTER.DATE_RANGE){
                        value = filterConfig[key].join(' to ')
                    }else if(column.filter === DATA_TABLE_FILTER.CHOOSE_OPTIONS){
                        const foundOptions = column.options.filter((option) => option.key.toString() === value.toString());
                        if(foundOptions.length > 0)
                            value = foundOptions[0].value;
                    }else if(column.filter === DATA_TABLE_FILTER.REPORT_DATE){
                        if(filterConfig[key].type === "range")
                            value = filterConfig[key].from+" to "+filterConfig[key].to
                        else if(filterConfig[key].type === "month")
                            value = moment(filterConfig[key].year+"-"+filterConfig[key].month+"-01").format("MMMM YYYY");
                        else
                            value = filterConfig[key].year
                    }
                    return (
                        <DataTableFilter key={index}>
                            <DataTableFilterData onClick={(e) => onClickFilter(e, column)} $forceFilter={column?.forceFilter}>
                                <span>{column.label}:</span> <b>{value}</b>
                            </DataTableFilterData>
                            {(column?.forceFilter)?(""):(
                                <DataTableFilterDelete onClick={(e) => onClickRemoveFilter(e, column)}>
                                    <FontAwesomeIcon icon={faTimes} />
                                </DataTableFilterDelete>
                            )}
                            
                        </DataTableFilter>
                    )
                })}
                <DataTableDropdown filter={true}/>
                <DataTableDropdown sort={true}/>
                
            </>
            
        </DataTableFilterContainer>
    )
}